module.exports = __webpack_public_path__ + "img/bi.e1ebb5ce.svg";